import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";

import authReducer from "./slices/authSlice";
import moduleReducer from "./slices/moduleSlice";
import tableReducer from "./slices/tableSlice";
import ruleTableReducer from "./slices/RuletableSlice";
import { authApi } from "../api/services/authApi";
import { moduleApi } from "../api/services/moduleApi";
import { userManagementApi } from "../api/services/userManagementAPI";
import { plantApi } from "../api/services/plantApi";
import { ruleApi } from "../api/services/ruleApi";
import { materialApi } from "../api/services/materialApi";
import { approverApi } from "../api/services/approverApi";
import  ApproverruleTable  from "./slices/ApproverRuletableSlice";
import { shopkeeperApi } from "../api/services/shopkeeperApi";
// Persist configuration
const persistConfig = {
  key: "root",
  version: 1,
  storage,
  whitelist: ["auth", "module"], // only these reducers will be persisted
};

const rootReducer = combineReducers({
  auth: authReducer,
  module: moduleReducer,
  [authApi.reducerPath]: authApi.reducer,
  [moduleApi.reducerPath]: moduleApi.reducer,
  [userManagementApi.reducerPath]: userManagementApi.reducer,
  [plantApi.reducerPath]: plantApi.reducer,
  [ruleApi.reducerPath]: ruleApi.reducer,
  [materialApi.reducerPath]: materialApi.reducer,
  [approverApi.reducerPath]: approverApi.reducer,
  [shopkeeperApi.reducerPath]:shopkeeperApi.reducer,
  table: tableReducer,
  ruleTable: ruleTableReducer,
  ApproverruleTable: ApproverruleTable,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(
      authApi.middleware,
      moduleApi.middleware,
      userManagementApi.middleware,
      plantApi.middleware,
      ruleApi.middleware,
      materialApi.middleware,
      approverApi.middleware,
      shopkeeperApi.middleware
    ),
});

export const persistor = persistStore(store);

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;